import {CampaignsService} from '../../libs/ui/src';
import {client} from '../apiService';

const _CampaignsService = new CampaignsService({client});

export {_CampaignsService as CampaignsService};
